export const ITEM_MOBILE_WIDTH = 260;
export const ITEM_MOBILE_HEIGHT = 240;
export const ITEM_DESKTOP_WIDTH = 260;
export const ITEM_DESKTOP_HEIGHT = 240;
export const ITEM_DESKTOP_MARGIN = 0;
export const ITEM_MOBILE_MARGIN = 0;

export const DEFAULT_TRANSLATION_DESKTOP = 0;
export const DEFAULT_TRANSLATION_MOBILE = 0;

export const ITEM_DESKTOP_FULL_WIDTH = ITEM_DESKTOP_WIDTH + ITEM_DESKTOP_MARGIN;
export const ITEM_MOBILE_FULL_WIDTH = ITEM_MOBILE_WIDTH + ITEM_MOBILE_MARGIN;
